<!-- 库房操作 -->
<template>
  <div class="demo-drawer__content data_action_form">
    <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
      <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
        :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
        <template slot="tabs" slot-scope="scope">
          <div v-if="scope.index == 0">
            <el-form class="form" id="mainInfo" size="mini" label-width="100px">
              <el-row>
                <el-form-item label="库房名称">
                  <el-input v-model.trim="sendDataInfo.stName" :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
                <el-form-item label="库房编号">
                  <el-input v-model.trim="sendDataInfo.stCode" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="库房地址">
                  <el-input type="textarea" v-model.trim="sendDataInfo.stAddress" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="仓库类型">
                  <el-select size="mini" v-model="sendDataInfo.stType" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否WMS">
                  <el-radio-group v-model="sendDataInfo.isWms">
                    <el-radio-button :label="0">否</el-radio-button>
                    <el-radio-button :label="1">是</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否门店库房">
                  <el-radio-group v-model="sendDataInfo.isStore">
                    <el-radio-button :label="0">否</el-radio-button>
                    <el-radio-button :label="1">是</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                  <el-form-item label="是否自动养护">
                  <el-radio-group v-model="sendDataInfo.isAutoCuring">
                    <el-radio-button :label="0">否</el-radio-button>
                    <el-radio-button :label="1">是</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否可出库">
                  <el-radio-group v-model="sendDataInfo.stIsgetout">
                    <el-radio-button :label="0">不可出库</el-radio-button>
                    <el-radio-button :label="1">可以出库</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否可入库">
                  <el-radio-group v-model="sendDataInfo.stIsputin">
                    <el-radio-button :label="0">不可入库</el-radio-button>
                    <el-radio-button :label="1">可以入库</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否医院运行库房">
                  <el-radio-group v-model="sendDataInfo.isRun">
                    <el-radio-button :label="0">否</el-radio-button>
                    <el-radio-button :label="1">是</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否备货库房">
                  <el-radio-group v-model="sendDataInfo.isStockUp">
                    <el-radio-button :label="0">否</el-radio-button>
                    <el-radio-button :label="1">是</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-row>
            </el-form>
          </div>
        </template>
      </v-tabs>
    </el-card>

    <div class="foots">
      <el-button type="primary" @click="initActionBox">取消</el-button>
      <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存</el-button>
      <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存</el-button>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: 'storageRoomAction',
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      options: [
        {
          value: 0,
          label: '整件拣货'
        },
        {
          value: 1,
          label: '拆零拣货'
        },
        {
          value: 2,
          label: '整零合一'
        }
      ],
      showTabs: "新增库房信息",
      sendDataInfo: {
        isStore: 0,
        isAutoCuring: 1,//是否自动养护
        stIsgetout: 0,   // 可出库
        stIsputin: 0,   // 	可入库
        isRun: 0,   // 	可入库
        isStockUp:0,//是否备货库房
        stName: '',   // 	库房名称
        stId: '',   // 库房ID
        isWms: 0,
        stCode: "",
        stAddress: "",
        stType:''
      },

    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    initActionBox() {
      this.$emit("drawerCancel");
      this.init();
    },
    init() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = ''
      }
      this.sendDataInfo.isStore = 0;
      this.sendDataInfo.isAutoCuring = 1;
      this.sendDataInfo.stIsgetout = 0;
      this.sendDataInfo.stIsputin = 0;
      this.sendDataInfo.isRun = 0;
      this.sendDataInfo.isStockUp = 0;
      this.sendDataInfo.isWms = 0;
    },
    openBox() {
      this.init()
      if (this.actionData.cate == 0) {
        this.dataActionBox.boxTitle = '新增库房信息'
      } else {
        this.dataActionBox.boxTitle = '编辑库房信息'
        for (let key in this.actionData.oldData) {
          this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
        }
      }
      this.showTabs = this.dataActionBox.boxTitle
      this.tabForm = [
        {
          jciName: this.dataActionBox.boxTitle,
          jurconfigform: [],
        }
      ]
      this.dataActionBox.actionType = this.actionData.cate
    },
    async sendDataAction() {
      if (this.sendDataInfo.stName == '') {
        this.$message({
          message: '请填写库房名称',
          type: 'error'
        });
        return false
      }
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.addStorageRoom(this.sendDataInfo)
      } else {
        var responseData = await this.$http.setStorageRoom(this.sendDataInfo)
      }

      if (responseData.status == 200) {
        this.$emit("drawerCancel", true);
        this.init();
        this.$message({
          message: '操作成功',
          type: 'success'
        });

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.openBox()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.form {
  padding-bottom: 10px;
}
</style>